
import { Text, Link, View } from '@smarterservices/smarter-ui';

/**
 * ManualLink Component
 * 
 * Displays a device link code in a visual format for manual entry when QR code scanning
 * is not available or fails. Each character of the code is displayed in an individual
 * styled box for easy reading and manual input on the second camera device.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.stepData - Step configuration data containing display texts
 * @param {string} props.stepData.deviceLinkCodeText - Label text for the device link code
 * @param {string} props.stepData.tryQrCodeScanAgainText - Text for the QR code retry link
 * @param {string} props.deviceLinkCode - The device link code to display character by character
 * @param {Function} props.setRightPaneContent - Function to change the right pane content
 * @returns {React.ReactElement} Manual link code display with retry option
 */
const ManualLink = ({ stepData, deviceLinkCode, setRightPaneContent }) => {

    return (
        <>
            {/* Header text for the device link code */}
            <View as="div">
                <Text size="large" fontWeight="bold">{stepData?.deviceLinkCodeText}:</Text>
            </View>
            
            {/* Visual display of each character in individual boxes */}
            <View as="div" margin="medium 0">
                {deviceLinkCode.split('').map((char, index) => (
                    <View 
                        key={index}
                        as="div" 
                        borderWidth="small"
                        borderColor="secondary" 
                        margin="xxx-small"
                        borderRadius="medium" 
                        background="secondary"
                        minWidth="30px"
                        minHeight="30px" 
                        display="inline-block"
                        textAlign="center"
                    >
                        <Text size="large" fontWeight="bold">{char}</Text>
                    </View>
                ))}
            </View>
            
            {/* Link to return to QR code scanning */}
            <View as="div" margin="medium 0">
                <Link
                    as="button"
                    onClick={() => {
                        setRightPaneContent('qrCode');
                    }}
                    isWithinText={false}
                    margin="0"
                >
                    {stepData?.tryQrCodeScanAgainText}
                </Link>
            </View>
        </>
    );
};

export default ManualLink;
